(() => {
  const ICONS = {
    'Colazione disponibile': '<path d="M4 18h16"></path><path d="M6 10h11v3a5 5 0 0 1-5 5h-1a5 5 0 0 1-5-5v-3Z"></path><path d="M17 11h1.5a2.5 2.5 0 0 1 0 5H17"></path><path d="M9 7c0-1.5 1.5-1.5 1.5-3"></path><path d="M13 7c0-1.5 1.5-1.5 1.5-3"></path>',
    'Servizio in camera': '<path d="M4 17h16"></path><path d="M6 17a6 6 0 0 1 12 0"></path><path d="M12 8V6"></path><path d="M10 6h4"></path><path d="M3 20h18"></path>',
    'Ascensore': '<rect x="5" y="3" width="14" height="18" rx="2"></rect><path d="M12 7v10"></path><path d="m9 10 3-3 3 3"></path><path d="m9 14 3 3 3-3"></path>',
    'Bar e lounge': '<path d="M6 4h12l-1 5a5 5 0 0 1-10 0L6 4Z"></path><path d="M12 14v6"></path><path d="M8 20h8"></path><path d="M7 8h10"></path>',
    'Camere familiari': '<circle cx="9" cy="8" r="3"></circle><circle cx="16.5" cy="9" r="2.5"></circle><path d="M3.5 20c.5-4 2.5-6 5.5-6s5 2 5.5 6"></path><path d="M14 15c1-.8 2-1.2 3.2-1.2 2.3 0 3.8 1.8 4.3 5.2"></path>',
    'Bagno privato con doccia walk-in': '<path d="M7 20V8a5 5 0 0 1 10 0"></path><path d="M14 8h6"></path><path d="M16 11v1"></path><path d="M19 11v1"></path><path d="M16 15v1"></path><path d="M19 15v1"></path><path d="M4 20h16"></path>',
    'Tè e caffè in camera': '<path d="M5 9h11v4a5 5 0 0 1-5 5h-1a5 5 0 0 1-5-5V9Z"></path><path d="M16 10h2a3 3 0 0 1 0 6h-3"></path><path d="M8 6c0-1.5 1.5-1.5 1.5-3"></path><path d="M12 6c0-1.5 1.5-1.5 1.5-3"></path><path d="M4 21h16"></path>'
  };

  function isViaRomaPage() {
    return window.location.pathname.replace(/\/$/, '') === '/pages/zagara-centro';
  }

  function removeLegacyBreakfastDuplicate() {
    const services = document.querySelector('.zm-amenities__services');
    if (!services) return;

    const hasConfiguredBreakfast = Array.from(
      services.querySelectorAll('.zm-amenity:not([data-zagara-breakfast-service]) h4')
    ).some((title) => title.textContent.trim() === 'Colazione disponibile');

    if (hasConfiguredBreakfast) {
      services.querySelector('[data-zagara-breakfast-service]')?.remove();
    }
  }

  function replaceIcon(title, iconMarkup) {
    const card = title.closest('.zm-amenity');
    const frame = card?.querySelector('.zm-amenity__icon');
    const existing = frame?.querySelector('svg');
    const label = title.textContent.trim();

    if (!frame || !existing || existing.dataset.zagaraServiceIcon === label) return;

    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.8');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('data-zagara-service-icon', label);
    svg.classList.add('zagara-service-icon--via-roma');
    svg.innerHTML = iconMarkup;

    frame.classList.add('zagara-service-icon-frame--via-roma');
    existing.replaceWith(svg);
  }

  function upgradeViaRomaIcons() {
    if (!isViaRomaPage()) return;

    removeLegacyBreakfastDuplicate();

    document.querySelectorAll('.zm-amenity h4').forEach((title) => {
      const iconMarkup = ICONS[title.textContent.trim()];
      if (iconMarkup) replaceIcon(title, iconMarkup);
    });
  }

  function scheduleUpgrade() {
    upgradeViaRomaIcons();
    window.setTimeout(upgradeViaRomaIcons, 80);
    window.setTimeout(upgradeViaRomaIcons, 250);
    window.setTimeout(upgradeViaRomaIcons, 600);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleUpgrade, { once: true });
  } else {
    scheduleUpgrade();
  }

  document.addEventListener('shopify:section:load', scheduleUpgrade);
})();
